const CheckOutSucess = () => {
    return <h2> Salio todo bien pa</h2>;
}

export default CheckOutSucess